module.exports = __webpack_public_path__ + "img/company-header-texture.afbf7455.svg";